import React from 'react'
import styles from './styles.module.css'
import { getIcon } from '../../../../assets/getIcon'
import { Upload } from 'antd'
const { Dragger } = Upload

export default function UploadCom(props) {
  const { maxCount = 1, uploadFucHandle, style = {} } = props

  function uploadFuc(data) {
    uploadFucHandle && uploadFucHandle(data)
  }

  const uploadOptions = {
    className: styles.zhyl_ckd_uploadel,
    maxCount: maxCount,
    name: 'file',
    customRequest: uploadFuc,
    showUploadList: false
  }
  return (
    <div
      style={{
        width: '1056px',
        height: '246px',
        ...style
      }}
    >
      <Dragger {...uploadOptions}>
        <div className={styles.zhyl_ckd_upload_title_dragger_up}>
          <img
            src={getIcon('up2x')}
            className={styles.zhyl_ckd_upload_title_dragger_img}
          />
          <span className={styles.zhyl_ckd_upload_title_dragger_p}>
            点击上传或将表格拖入此区域
          </span>
        </div>
      </Dragger>
    </div>
  )
}
